import { render, staticRenderFns } from "./CompetenceDialog.vue?vue&type=template&id=a294961e&scoped=true&lang=pug&"
import script from "./CompetenceDialog.vue?vue&type=script&lang=ts&"
export * from "./CompetenceDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a294961e",
  null
  
)

export default component.exports